import { useEffect, useRef } from "react";
import "./CreditNote.css";

const CreditNote = ({ onClose, data }) => {
  // const data = {
  //   doc_no: "CN-20250723-001",
  //   amount: "1234.56",
  //   invoiceNo: "INV-20250723-ABC",
  // };

  // Prevent multiple onClose calls
  const closedRef = useRef(false);
  const modalRef = useRef(null);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        (e.code === "Space" || e.key === " " || e.keyCode === 32) &&
        !closedRef.current
      ) {
        closedRef.current = true;
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="creditnote">
      <div className="creditnote-content" ref={modalRef}>
        <div className="cnclose-button">
          <button onClick={onClose}>&#10006;</button>
        </div>

        <div className="creditnote-content-container">
          <div className="creditnote-title">Knocked Credit Note</div>

          <div className="creditnote-main">
            {data.cnList && data.cnList.length > 0 ? (
              data.cnList.map((cn, idx) => (
                <div key={idx} className="creditnote-item">
                  <div className="creditnote-no">{cn.doc_no}</div>
                  <div className="creditnote-amt-container">
                    <div className="creditnote-subtitle">Amount</div>
                    <div className="creditnote-colon">:</div>
                    <div className="creditnote-value">
                      <div className="creditnote-RM">RM</div>
                      {cn.amount ? formatCurrency(cn.amount) : "0.00"}
                    </div>
                  </div>
                  {data.invoiceNo && (
                    <div className="creditnote-inv-container">
                      <div className="creditnote-subtitle">Invoice No</div>
                      <div className="creditnote-colon">:</div>
                      {data.invoiceNo}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div>No credit notes found.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditNote;
